import {createStrokeSVG} from './TEMPLATE'

// tabler: edit
export const EditBig_Stroke1_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1',
    'M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415',
    'M16 5l3 3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// tabler: edit
export const EditBig_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1',
    'M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415',
    'M16 5l3 3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
